import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout/Layout";
import HelpHeader from "../../components/Help/HelpHeader";
import ContactCard from "../../components/Help/ContactCard";
import FaqList from "../../components/Help/FaqList";
import StepsList from "../../components/Help/StepsList";
import RewardsGrid from "../../components/Help/RewardsGrid";
import { fetchAndCacheFaq, getCachedFaq } from "../../api/postgre/faqApi";

const STEP_KEYS = [
    "HELP_STEP_1",
    "HELP_STEP_2",
    "HELP_STEP_3",
    "HELP_STEP_4",
    "HELP_STEP_5",
];

const rewards = [
    { image: "/assets/images/landing/landing-3.2.png", labelKey: "LANDING_REWARD_FREE_PRODUCTS" },
    { image: "/assets/images/landing/landing3.3.png", labelKey: "LANDING_REWARD_DISCOUNT_CODES" },
    { image: "/assets/images/landing/landing3.5.png", labelKey: "LANDING_REWARD_AFFILIATE_COMMISSIONS" },
    { image: "/assets/images/landing/landing3.4.png", labelKey: "LANDING_REWARD_EXCLUSIVE_EVENTS" },
    { image: "/assets/images/landing/landing-3.1.png", labelKey: "LANDING_REWARD_REPOSTS" },
];

const Help = () => {
    const { i18n, t } = useTranslation();
    const steps = STEP_KEYS.map((key) => t(key));
    const language = i18n.language || "en";

    const [faqItems, setFaqItems] = useState(() => {
        const cached = getCachedFaq(language);
        return cached ? cached.map((item) => ({ id: item.id, question: item.q, answer: item.a })) : [];
    });

    useEffect(() => {
        fetchAndCacheFaq(language)
            .then((items) => setFaqItems(items.map((item) => ({ id: item.id, question: item.q, answer: item.a }))))
            .catch(() => {});
    }, [language]);

    return (
        <Layout activeLabel="Help">
            <div>
                <HelpHeader />
                <ContactCard />
                <FaqList items={faqItems} />
                <StepsList steps={steps} />
                <RewardsGrid items={rewards} />
            </div>
        </Layout>
    );
};

export default Help;
